<template>
    <div class="contactUs_main">
        <div class="content">
            <h2>法律声明</h2>
            <h2>·&nbsp;权利声明</h2>
            <p>
                1、本网站由苏州爱洛克信息技术有限公司（以下简称“苏州爱洛克”）创设，苏州爱洛克合法地拥有本网站域名并受相关法律保护。
            </p>
            <p>
                2、本网站提供的任何内容（包括但不限于文字、软件、数据、图表、图象、声音或视频等）的版权均属于苏州爱洛克或相关权利人。未经爱洛克或相关权利人事先的书面许可，
                浏览者不得出于商业目的以任何方式擅自复制、再造、传播、出版、改编或陈列本网站的内容。任何未经授权使用本网站的行为都将违反《中华人民共和国著作权法》和其他相关法律法规以及国际公约的规定，
                苏州爱洛克充分保留追究相应法律责任的权利。
            </p>
            <p>
                3、苏州爱洛克对其发行的包括但不限于产品或服务的全部内容及本网站上的所有展示页面拥有知识产权，苏州爱洛克或本网站提供的其他产品服务名称及相关图形、标识等为苏州爱洛克的注册商标，受法律保护。
            </p>
            <h2>·&nbsp;免责声明</h2>
            <p>
                1、苏州爱洛克不保证本网站上任何内容的准确性、完整性和可靠性以及使用这些内容可能得出的任何结果。苏州爱洛克及相关人员不能保证浏览者任何时候均可进入、浏览和使用本网站；
                苏州爱洛克对本网站和其内容的不能使用和使用错误不承担任何责任。
            </p>
            <p>
                2、本网站对其他网站的链接本身并不表示苏州爱洛克认可或承担其他网站内容或使用上的责任。
            </p>
            <p>
                3、使用者对本网站的使用即表明同意承担浏览本网站的全部风险，苏州爱洛克以及相关人员对于在进入、浏览和使用本网站、从本网站下载任何内容或通过本网站的任何链接进入其他网站而导致病毒或其他破坏性程序对使用者的电脑系统以及其他任何软件、硬件、IT系统或财产的损害或损失不承担任何责任。
            </p>
            <p>
                4、苏州爱洛克以及相关人员对于第三人采用非法手段进入本网站取得有关密码、资料和内容而引起的任何直接及间接损害或损失不承担任何责任。
            </p>
            <h2>·&nbsp;适用法律</h2>
            <p>
                本网站及网站声明，适用中华人民共和国法律。任何有关本网站及网站声明的争议，应由苏州爱洛克住所地有管辖权的人民法院管辖。
            </p>
            <h2>·&nbsp;解释权</h2>
            <p>
                本网站所有资料的解释说明权归苏州爱洛克所有。苏州爱洛克有权对本网站的资料随时进行修改和更新。
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "legalNotice",
    data() {
        return {
            loading: true,
        };
    },
    mounted: function () {},
    computed: {},
    watch: {
        getUserLangs(val) {},
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.contactUs_main {
    width: 100%;
    background: #1d222c;
    .content {
        position: relative;
        width: 12rem;
        margin: 0 auto;
        font-size: 0.15rem;
        line-height: .35rem;
        padding: 1.6rem 0 1rem;
        color: #fff;
        h2{
            display: block;
            width: 100%;
            margin: .4rem 0 auto;
            font-size: .18rem;
            font-style: normal;
            font-weight: 550;
            &:nth-of-type(1) {
                font-size: .3rem;
                text-align: center;
            }
        }
    }
}
.page-banner {
    width: 100%;
    height: 0;
    padding-bottom: 32.38%;
    position: relative;
    background: #202630;
}
.page-banner img {
    width: 100%;
}
</style>